import { html, LitElement } from 'lit-element';

/**
 * @element response-block
 */
export class ResponseBlock extends LitElement {
  static get properties() {
    return {};
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <div class="block">Response Block for Unknown Tag</div>`;
  }
}

export default ResponseBlock;
